import { FormControlLabel, Grid2 as Grid, Switch } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import * as yup from "yup"
import { Fondo } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogEditProps } from "../DialogForm"
import { ACVocabolarioFormik } from "./autocompletes"
import { FormikDatePicker, FormikSelectVocabolario, FormikTextField } from "./formsHelpers"

export default function FondoFormContenuto({ item, save, ref, language }: FormInDialogEditProps<Fondo>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        // descrizione: yup.string().required().label(t("fondo.descrizione")),
        // modo_acquisizione: yup.number().required().label(t("fondo.modo_acquisizione")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={item}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Fondo).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="criteri_ordinamento"
                  label={t("fondo.criteri_ordinamento")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="modo_acquisizione"
                  label={t("fondo.modalita_acquisizione")}
                  component={ACVocabolarioFormik}
                  vocabolario="fondo_modo_acquisizione"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={6}>
                <Field
                  name="tipo_acquisizione"
                  label={t("fondo.tipo_acquisizione")}
                  component={FormikSelectVocabolario}
                  vocabolario="fondo_tipo_acquisizione"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="note_tipo_acquisizione"
                  label={t("fondo.note_tipo_acquisizione")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  minRows={6}
                />
              </Grid>
              <Grid size={4}>
                <Field
                  name="data_acquisizione"
                  label={t("fondo.data_acquisizione")}
                  component={FormikDatePicker}
                  type="date"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={8}>
                <Field
                  name="consegna"
                  label={t("fondo.consegna")}
                  component={FormikSelectVocabolario}
                  vocabolario="fondo_consegna"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="materiali_suppl_consegnati_it"
                    label={t("fondo.materiali_suppl_consegnati")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="materiali_suppl_consegnati_en"
                    label={t("fondo.materiali_suppl_consegnati_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="materiali_suppl_esistenti_it"
                    label={t("fondo.materiali_suppl_esistenti")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="materiali_suppl_esistenti_en"
                    label={t("fondo.materiali_suppl_esistenti_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="storia_archivistica_it"
                    label={t("fondo.storia_archivistica")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="storia_archivistica_en"
                    label={t("fondo.storia_archivistica_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={4}>
                <Field
                  name="stato_conservazione"
                  label={t("fondo.stato_conservazione")}
                  component={FormikSelectVocabolario}
                  vocabolario="fondo_stato_cons"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="note_stato_conservazione_it"
                    label={t("fondo.note_stato_conservazione")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="note_stato_conservazione_en"
                    label={t("fondo.note_stato_conservazione_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={values.contributo}
                      onChange={(e) => setFieldValue("contributo", e.target.checked)}
                    />
                  }
                  label={t("fondo.contributo")}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
